import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import Selectors from '@/vocabularies/hooks/selectors';
import ExternalLinksLogo from '@/components/navbar/ExternalLinksLogo';

const listItems = (items) => (
  items.map((item) => (
    <Dropdown.Item
      key={`external_link_${item.name}`}
      title=""
      as="a"
      href={item.href}
      target={item.target}
    >
      {item.name}
    </Dropdown.Item>
  ))
);

const ExternalLinksDropdown = () => {
  const { linksName, links } = Selectors.useExternalLinks();
  if (!hasMinimumLength(linksName) || !Array.isArray(links) || links.length === 0) {
    return null;
  }

  return (
    <Dropdown
      simple
      className="item aridhia-external-links-dropdown"
      title={linksName}
      trigger={<ExternalLinksLogo linksName={linksName} />}
    >
      <Dropdown.Menu>
        {listItems(links)}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ExternalLinksDropdown;
